import { Activity } from "lucide-react";

const DISCIPLINES = [
  "Pressure",
  "Temperature",
  "Flow meters",
  "Electrical",
  "Conductivity",
  "pH",
  "Relative humidity",
  "Level",
];

function DisciplineRow() {
  return (
    <div className="flex shrink-0 items-center">
      {DISCIPLINES.map((item, i) => (
        <span key={i} className="flex items-center gap-5 pr-10">
          <span className="font-mono text-[11px] tracking-[0.2em] text-brand">[{String(i + 1).padStart(2, "0")}]</span>
          <span className="whitespace-nowrap font-heading text-2xl font-semibold uppercase tracking-tight text-ink md:text-3xl">
            {item}
          </span>
          <span aria-hidden="true" className="h-1.5 w-1.5 rotate-45 bg-brand/70" />
        </span>
      ))}
    </div>
  );
}

/** Single scrolling row with a pinned "live scope" badge and soft edge fades. */
export default function Marquee() {
  return (
    <div
      data-testid="disciplines-marquee"
      aria-hidden="true"
      className="marquee-track relative overflow-hidden border-y border-line/10 bg-base"
    >
      <div className="relative py-5">
        <div className="animate-marquee flex w-max">
          <DisciplineRow />
          <DisciplineRow />
        </div>
      </div>

      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 flex items-stretch">
        <div className="glass flex items-center gap-3 border-r border-line/10 py-2.5 pl-6 pr-5 md:pl-12">
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-brand/70" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-brand" />
          </span>
          <Activity className="h-3.5 w-3.5 text-brand" />
          <span className="hud-label whitespace-nowrap">Accredited scope</span>
        </div>
        <div className="w-28 bg-gradient-to-r from-base to-transparent" />
      </div>
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-32 bg-gradient-to-l from-base to-transparent" />
    </div>
  );
}
